var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
//component
import EhpPagination from "../../common/pagination/EhpPagination";
import HilightSpan from "../../common/highlight/HilightSpan";
/**
 * @brief EHP 사업장 전기실 관리 - 회사/사업장 List 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function ZoneList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //화면 이동
    const navigate = useNavigate();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    //
    const [companyZoneList, setCompanyZoneList] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: ""
    });
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&search=` + searchTextField.searchText;
    }
    clog("IN ZONELIST : " + appPath);
    ////////////////////////////////////////////////////////////////////////////
    const { data: retList, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/companyzones?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: curTree.company.companyId + appPath
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retList);
        clog("IN ZONELIST :  > " + isLoading + " : " + JSON.stringify(retList));
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retList) {
            if (retList.codeNum == CONST.API_200) {
                clog("IN COMPZONELIST : RES : " + JSON.stringify(retList.data.page));
                setParentPopWin("pop-area-rigth", 
                //setParentPopWin("pop-area-right-page-info", 
                React.createElement(MobileZoneList, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"), searchText: searchText, setSearchText: setSearchText, searchTextField: searchTextField, companyZoneList: retList.body, pageInfo: retList.data.page, setPageInfo: handleCurPage, onClickGoSearch: onClickGoSearch, onClickZoneInsert: onClickZoneInsert, onClickWorkPlaceAprv: onClickWorkPlaceAprv }));
                setCompanyZoneList(retList.body);
                setPageInfo(retList.data.page);
            } /* else {
              clog("------------RESPONSE ERROR>..............................");
              navigate(CONST.URL_NOT_FOUND);
            }*/
        } /* else { // system error 처리
          clog("----------CONNECTION ERROR>..............................");
          navigate(CONST.URL_NOT_FOUND);
        }*/
    }, [curTree, retList, searchText]);
    /*
    //////////////////////////////////////////////////////////////////////////
    clog("IN SITEIVEW : INIT : curTree : " + JSON.stringify(curTree));
    (zoneInfo)
    ?clog("IN SITEIVEW : INIT : companyInfo : " + JSON.stringify(zoneInfo.company) + " : zoneInfo : " + JSON.stringify(zoneInfo.zone))
    :clog("IN SITEIVEW : INIT : companyInfo : " + "null");
    //clog("IN SITEIVEW : INIT : zoneInfo : " + (zoneInfo)?JSON.stringify(zoneInfo.zone):"null");
    */
    function onClickZoneInsert(e) {
        setParentWorkMode("CREATE");
    }
    function onClickGoSearch(e) {
        setSearchTextField({
            searchField: "",
            searchText: ""
        });
        /*
            var searchTypeDiv = document.querySelector("#search_selected-value");
            clog("onClickGoSearch : DEVICE : " + searchTypeDiv);
            if (CUTIL.isnull(searchTypeDiv)) return;
            var selSearchType = searchTypeDiv.getAttribute("data-value");
        */
        setSearchTextField({
            searchField: "",
            searchText: searchText
        });
        // search시 필터 적용
        /*
        setSearchFilterList(
          filterList.filter((filter) => filter.checked)
        );
        */
    }
    function onClickWorkPlaceAprv(e, czoneInfo) {
        setParentPopWin("pop-workplace", React.createElement(WorkPlacePopup, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uD5C8\uC6A9 \uC694\uCCAD"), czoneInfo: czoneInfo, curTree: props.curTree, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode }));
        CUTIL.jsopen_Popup(e);
    }
    return (React.createElement(React.Fragment, null, React.createElement("div", { className: "area__right", ref: mobileRef },
        React.createElement("h2", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"),
        React.createElement("ul", { className: "tab__small" },
            React.createElement("li", { className: "on" },
                React.createElement("a", { href: "#", className: "icon-search" }, "\uAC80\uC0C9")),
            React.createElement("li", null,
                React.createElement("a", { href: "#", className: "icon-pen", onClick: (e) => onClickZoneInsert(e) }, "\uC2E0\uADDC\uB4F1\uB85D"))),
        React.createElement("div", { className: "area__right_content" },
            React.createElement("div", { className: "searcharea" },
                React.createElement("div", { className: "searchinput" },
                    React.createElement("span", { className: "hide" }, "\uAC80\uC0C9"),
                    React.createElement("div", { className: "input__direct" },
                        React.createElement("input", { type: "text", placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694", className: "w274", value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                        (searchText.length > 0) &&
                            React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))),
                    React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickGoSearch(e) },
                        React.createElement("span", null, "\uC870\uD68C")))),
            React.createElement("div", { className: "tbl-list type3 w800" },
                React.createElement("table", { summary: "\uC0AC\uC5C5\uC7A5\uBA85, \uC9C0\uC5ED\uBA85, \uC8FC\uC18C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC5C5\uC7A5 \uCD94\uAC00 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "90%" } }),
                        React.createElement("col", { style: { "width": "10%" } })),
                    React.createElement("tbody", null, (companyZoneList) && companyZoneList.map((czones, idx) => (React.createElement("tr", { key: `tr_${idx.toString()}` },
                        React.createElement("td", null,
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement("p", { className: "placename" },
                                        React.createElement(HilightSpan, { key: `comp_${idx.toString()}`, word: czones.companyName, keyword: searchTextField.searchText })),
                                    React.createElement("p", { className: "location" },
                                        React.createElement(HilightSpan, { key: `zone_${idx.toString()}`, word: czones.zoneName, keyword: searchTextField.searchText }))),
                                React.createElement("li", { className: "address" }, czones.zoneAddress))),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn-add center js-open", "data-pop": "pop-workplace", onClick: (e) => onClickWorkPlaceAprv(e, czones) },
                                React.createElement("span", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00")))))))),
                (pageInfo) && React.createElement(EhpPagination, { componentName: "ZONELIST", pageInfo: pageInfo, handleFunc: handleCurPage }))))));
}
export default ZoneList;
function MobileZoneList(props) {
    const companyZoneList = props.companyZoneList;
    const pageInfo = props.pageInfo;
    const handleCurPage = props.setPageInfo;
    const searchText = props.searchText;
    const setSearchText = props.setSearchText;
    const searchTextField = props.searchTextField;
    const onClickGoSearch = props.onClickGoSearch;
    const onClickZoneInsert = props.onClickZoneInsert;
    const onClickWorkPlaceAprv = props.onClickWorkPlaceAprv;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right", id: "pop-area-right" },
                React.createElement("ul", { className: "tab__small" },
                    React.createElement("li", { className: "on" },
                        React.createElement("a", { href: "#", className: "icon-search" }, "\uAC80\uC0C9")),
                    React.createElement("li", null,
                        React.createElement("a", { href: "#", className: "icon-pen", onClick: (e) => onClickZoneInsert(e) }, "\uC2E0\uADDC\uB4F1\uB85D"))),
                React.createElement("div", { className: "area__right_content" },
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("span", { className: "hide" }, "\uAC80\uC0C9"),
                            React.createElement("div", { className: "input__direct" },
                                React.createElement("input", { type: "text", placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694", className: "w274", value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                (searchText.length > 0) &&
                                    React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                        React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))),
                            React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickGoSearch(e) },
                                React.createElement("span", null, "\uC870\uD68C")))),
                    React.createElement("div", { className: "tbl-list type3 w800" },
                        React.createElement("table", { summary: "\uC0AC\uC5C5\uC7A5\uBA85, \uC9C0\uC5ED\uBA85, \uC8FC\uC18C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC5C5\uC7A5 \uCD94\uAC00 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                            React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uB9AC\uC2A4\uD2B8"),
                            React.createElement("colgroup", null,
                                React.createElement("col", { style: { "width": "90%" } }),
                                React.createElement("col", { style: { "width": "10%" } })),
                            React.createElement("tbody", null, (companyZoneList) && companyZoneList.map((czones, idx) => (React.createElement("tr", { key: `tr_m_${idx.toString()}` },
                                React.createElement("td", null,
                                    React.createElement("ul", null,
                                        React.createElement("li", null,
                                            React.createElement("p", { className: "placename" },
                                                React.createElement(HilightSpan, { key: `comp_${idx.toString()}`, word: czones.companyName, keyword: searchTextField.searchText })),
                                            React.createElement("p", { className: "location" },
                                                React.createElement(HilightSpan, { key: `zone_${idx.toString()}`, word: czones.zoneName, keyword: searchTextField.searchText }))),
                                        React.createElement("li", { className: "address" }, czones.zoneAddress))),
                                React.createElement("td", null,
                                    React.createElement("button", { type: "button", className: "btn-add center", "data-pop": "pop-workplace", onClick: (e) => onClickWorkPlaceAprv(e, czones) },
                                        React.createElement("span", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00")))))))),
                        (pageInfo) && React.createElement(EhpPagination, { componentName: "ZONELIST", pageInfo: pageInfo, handleFunc: handleCurPage })))))));
}
function WorkPlacePopup(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const curTree = props.curTree;
    const czoneInfo = props.czoneInfo;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    function onClickApproval(czone) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "product": "zone",
                    "productName": czone.zoneName,
                    "productParentId": czone.companyId,
                    "approval": 1,
                    "isontree": true
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN APPROVAL : RES : " + JSON.stringify(data.body));
                    setParentCurTree("ZONE", Object.assign(Object.assign({}, curTree), { 
                        //subZone: { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName },
                        reload: true }));
                    setParentWorkMode("LIST");
                }
                else { // api if
                    // need error handle
                    alert(data.body.errorList[0].msg);
                }
                CUTIL.jsclose_Popup("pop-workplace");
            }
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-workplace");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null,
                "\uB2F4\uB2F9\uC790\uC5D0\uAC8C \uC0AC\uC5C5\uC7A5 \uB4F1\uB85D\uC744 \uC694\uCCAD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                React.createElement("br", null),
                "\uB2F4\uB2F9\uC790 \uD655\uC778 \uD6C4 \uC0AC\uC5C5\uC7A5 \uC811\uADFC\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray btn btn-close js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "btn-close", onClick: (e) => onClickApproval(czoneInfo) },
                React.createElement("span", null, "\uD655\uC778")))));
}
